export default __webpack_public_path__ + "static/media/homeImg.38eb2ddc.jpg";